import React, { useState } from 'react';
import { useAuth } from '../../systems/auth-context';
import { apiFetch } from '../../systems/api-client';
import DepartmentPicker from './DepartmentPicker';
import styles from './auth.module.css';

interface DepartmentSetupProps {
  onComplete: () => void;
}

const DepartmentSetup: React.FC<DepartmentSetupProps> = ({ onComplete }) => {
  const { updateSession } = useAuth();
  const [department, setDepartment] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    try {
      const response = await apiFetch('/api/auth/department', {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ department }),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || 'Échec de la mise à jour du rôle');
      }
      updateSession(data.user);
      onComplete();
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Une erreur est survenue');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.authContainer}>
      <h2>Choisissez votre rôle</h2>
      <p className={styles.description}>
        Pour personnaliser votre expérience et les statistiques, indiquez votre rôle dans l&apos;organisation.
      </p>
      {error && <div className={styles.error}>{error}</div>}
      <form onSubmit={handleSubmit}>
        <DepartmentPicker value={department} onChange={setDepartment} />
        <button type="submit" className={styles.submitBtn} disabled={isSubmitting || !department}>
          {isSubmitting ? 'Enregistrement...' : 'Continuer'}
        </button>
      </form>
    </div>
  );
};

export default DepartmentSetup;
